<template>
    <div class="card mt-4">
        <div class="card-body">
            <div class="row">
                <h5>Uitleg rechten</h5>
            
                <p class="text-sm">
                Op deze pagina stel je per rol in welke rechten gebruikers hebben binnen de verschillende onderdelen van de app, zoals nieuws, evenementen, locaties, FAQ, bedrijfspagina’s, polls en vacatures.
                </p>
                
                <p class="text-sm">
                    De rechten gelden altijd voor <strong>alle berichten binnen de gekozen categorie</strong>. Een ingeschakelde toggle betekent dus niet dat iemand alleen rechten heeft op eigen berichten, maar op de volledige categorie.
                </p>

                <p class="text-sm text-center d-flex align-items-center justify-content-start fw-bold mb-0">
                    <i class="material-icons-round opacity-10">warning</i>
                    <span>Let op!</span>
                </p>

                <p class="text-sm">                
                    <em>Geef wijzig- en verwijderrechten alleen aan gebruikers die verantwoordelijk zijn voor het beheer van de inhoud binnen deze categorie.</em>
                </p>
                <hr />

                <p class="text-sm">
                    <strong>Aanmaken</strong><br>
                    Met dit recht kan een gebruiker nieuwe berichten aanmaken binnen deze categorie.
                    Heeft een gebruiker zelf een bericht aangemaakt, dan mag deze gebruiker dat eigen bericht automatisch ook later aanpassen.
                </p>

                <hr />

                <p class="text-sm">
                    <strong>Wijzigen</strong><br>
                    Met dit recht kan een gebruiker <strong>alle berichten</strong> binnen deze categorie wijzigen, ook berichten die door anderen zijn aangemaakt.
                </p>

                <hr />
                
                <p class="text-sm">
                    <strong>Verwijderen</strong><br>
                    Met dit recht kan een gebruiker <strong>alle berichten</strong> binnen deze categorie verwijderen, ook berichten die door anderen zijn aangemaakt.
                </p>

                <hr />

                <p class="text-sm">
                    <strong>Reageren</strong><br>
                    Met dit recht kan een gebruiker reageren op alle berichten binnen deze categorie.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>